module.exports = __webpack_public_path__ + "static/img/fefco421_2.6220631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco421_2.png
// module id = yX1H
// module chunks = 0